import DeviceDetect from './device-detect'

export default DeviceDetect
